module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-57x57-precomposed-b6199ad72d2877461c5654fdfcffa60c.png";